// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let IconsJson = require("../../../../assets/icons.json");

let icons = IconsJson;

function IconV5(props) {
  let __className = props.className;
  let __cursorPointer = props.cursorPointer;
  let __size = props.size;
  let size = __size !== undefined ? __size : 16;
  let cursorPointer = __cursorPointer !== undefined ? __cursorPointer : false;
  let className = __className !== undefined ? __className : "";
  let cls = TailwindMerge.twMerge([
    "flex-none",
    cursorPointer ? "cursor-pointer" : "",
    className
  ]);
  let size$1 = size.toString();
  let def = icons[props.icon];
  if (def !== undefined) {
    return JsxRuntime.jsx("svg", {
      children: JsxRuntime.jsx("path", {
        d: def.path
      }),
      className: cls,
      role: "img",
      height: size$1,
      width: size$1,
      onClick: props.onClick,
      fill: "currentColor",
      viewBox: def.viewBox
    });
  } else {
    return null;
  }
}

let make = IconV5;

exports.icons = icons;
exports.make = make;
/* icons Not a pure module */
